document.addEventListener('DOMContentLoaded', function () {
  var contactLocale = (document.documentElement.lang || 'es').toLowerCase().split('-')[0];
  var contactCopy = {"es":["Enviar WhatsApp","¡Hola! He visto vuestro atelier y quiero más información."],"ca":["Enviar WhatsApp","Hola! He vist el vostre atelier i vull més informació."],"en":["Message on WhatsApp","Hello! I have seen your atelier and would like more information."],"fr":["Envoyer un WhatsApp","Bonjour ! J'ai découvert votre atelier et je souhaite en savoir plus."],"de":["WhatsApp schreiben","Hallo! Ich habe euer Atelier entdeckt und möchte mehr erfahren."],"it":["Scrivi su WhatsApp","Ciao! Ho scoperto il vostro atelier e vorrei maggiori informazioni."],"pt":["Enviar WhatsApp","Olá! Conheci o vosso atelier e gostaria de obter mais informações."]};
  var contactText = contactCopy[contactLocale] || contactCopy.es;
  var whatsappBtn = document.createElement('a');
  whatsappBtn.href = 'https://api.whatsapp.com/send?phone=34935929690&text=' + encodeURIComponent(contactText[1]);
  var contextualLink = document.querySelector('[data-yvicor-product-contact]');
  if (contextualLink) whatsappBtn.href = contextualLink.href;
  whatsappBtn.addEventListener('click', function () {
    var currentLink = document.querySelector('[data-yvicor-product-contact]');
    if (currentLink) whatsappBtn.href = currentLink.href;
  });
  whatsappBtn.className = 'whatsapp-float';
  whatsappBtn.target = '_blank';
  whatsappBtn.rel = 'noopener noreferrer';
  whatsappBtn.setAttribute('aria-label', contactText[0]);

  whatsappBtn.innerHTML =
    '<svg viewBox="0 0 32 32" fill="white" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M16.001 3C9.373 3 4 8.373 4 15c0 2.634.87 5.07 2.34 7.037L4.8 27.2l5.29-1.51A11.94 11.94 0 0 0 16.001 27C22.63 27 28 21.627 28 15S22.63 3 16.001 3zm.06 21.6c-1.99 0-3.85-.56-5.44-1.53l-.39-.23-3.22.92.94-3.14-.25-.4A9.55 9.55 0 0 1 6.4 15c0-5.3 4.31-9.6 9.6-9.6s9.6 4.3 9.6 9.6-4.31 9.6-9.6 9.6zm5.31-7.19c-.29-.15-1.72-.85-1.99-.95-.27-.1-.46-.15-.66.15-.2.29-.76.95-.93 1.14-.17.2-.34.22-.63.07-.29-.15-1.24-.46-2.35-1.46-.87-.78-1.46-1.74-1.63-2.03-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.5.15-.17.2-.29.29-.49.1-.2.05-.37-.02-.51-.07-.15-.66-1.6-.91-2.2-.24-.57-.48-.5-.66-.51h-.56c-.2 0-.51.07-.78.37-.27.29-1.02 1-1.02 2.44s1.05 2.83 1.19 3.03c.15.2 2.07 3.16 5.02 4.43.7.3 1.25.48 1.68.62.7.22 1.34.19 1.85.12.56-.08 1.72-.7 1.96-1.38.24-.68.24-1.26.17-1.38-.07-.12-.26-.2-.55-.35z"/>' +
    '</svg>';

  document.body.appendChild(whatsappBtn);

  // En la ficha de producto, Horizon muestra una barra fija de "Añadir al
  // carrito" al hacer scroll (componente <sticky-add-to-cart>). Sin este
  // ajuste, esa barra queda justo debajo del botón de WhatsApp y lo tapa.
  // Observamos su atributo data-stuck y, mientras esté visible, subimos el
  // botón de WhatsApp la altura real de la barra (medida en cada cambio,
  // por si varía entre escritorio y móvil). Además reevaluamos la altura en
  // cada resize/orientationchange mientras la barra sigue pegada, por si el
  // contenido de la barra cambia de una a dos líneas (p. ej. al girar el
  // móvil o cambiar de variante).
  var stickyCartBar = document.querySelector('sticky-add-to-cart [ref="stickyBar"]');

  if (stickyCartBar) {
    var updateWhatsappOffset = function () {
      var isStuck = stickyCartBar.getAttribute('data-stuck') === 'true';

      if (isStuck) {
        whatsappBtn.style.setProperty('--sticky-cart-height', stickyCartBar.offsetHeight + 'px');
        whatsappBtn.classList.add('whatsapp-float--raised');
      } else {
        whatsappBtn.classList.remove('whatsapp-float--raised');
      }
    };

    var stickyCartObserver = new MutationObserver(updateWhatsappOffset);
    stickyCartObserver.observe(stickyCartBar, { attributes: true, attributeFilter: ['data-stuck'] });

    // La altura de la barra también puede cambiar sin que cambie data-stuck
    // (p. ej. el texto del botón pasa a dos líneas en una pantalla estrecha),
    // así que además vigilamos el tamaño de la propia barra.
    if (window.ResizeObserver) {
      var stickyCartResizeObserver = new ResizeObserver(updateWhatsappOffset);
      stickyCartResizeObserver.observe(stickyCartBar);
    }

    window.addEventListener('resize', updateWhatsappOffset);
    updateWhatsappOffset();
  }
});
